import { COLORS } from "./color.const";

export enum BookingProcessStatus {
  SUCCESS = "success",
  FAILED = "failed",
}

export enum CancelProcessStatus {
  SUCCESS = "success",
  FAILED = "failed",
}

export enum PTBookingStatus {
  BOOKING_SUCCESS = "BOOKING_SUCCESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  NOT_PARTICIPATED = "NOT_PARTICIPATED"
}

export enum BookingStatus {
  BOOKING_SUCCESS = "Booking success",
  CANCELLED = "Cancel",
  COMPLETED = "Completed",
  NOT_PARTICIPATED = "Not participating",
}

export const BookingStatusColor: Record<PTBookingStatus, string> = {
  [PTBookingStatus.BOOKING_SUCCESS]: "success.main",
  [PTBookingStatus.CANCELLED]: COLORS.text.onDarkMuted,
  [PTBookingStatus.COMPLETED]: "success.main",
  [PTBookingStatus.NOT_PARTICIPATED]: "error.main"
};

export enum GoalSettingStatus {
  INPROGRESS = "Training in Progress",
  NEED_IMPROVEMENT = "Need Improvement",
  SUCCESS = "Success",
}

export const GoalSettingStatusColor: Record<GoalSettingStatus, string> = {
  [GoalSettingStatus.INPROGRESS]: "warning.main",
  [GoalSettingStatus.NEED_IMPROVEMENT]: "error.main",
  [GoalSettingStatus.SUCCESS]: "success.main",
};

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  NOT_SPECIFIED = "NOT_SPECIFIED"
}

export enum MEMBER_TYPE {
  MEMBER = "member",
  SESSION_MEMBER = "session",
  DROP_IN = "drop-in",
}
